// ═══════════════════════════════════════════════════════════════
// CashbackConfig — Configuration centralisée des taux de cashback
//
// Les taux ci-dessous s'appliquent à la commission CJ nette reçue par Outfit.
// Exemple : user achète 100€, commission CJ nette = 8€
//   → user Free reçoit 5% × 8€ = 0,40€ de cashback
//   → user Gold reçoit 25% × 8€ = 2,00€ de cashback
// ═══════════════════════════════════════════════════════════════

// Taux de cashback par tier (en pourcentage de la commission CJ nette)
// v1.12.313 — Nouveau barème : Free 10% / Basic 15% / Premium 25% / Gold 40%
//             Les pourcentages ne sont plus affichés dans l'UI (cf. issue cashback).
export const CASHBACK_RATES = {
  free:    0.10,
  basic:   0.15,
  premium: 0.25,
  gold:    0.40,
};

// Seuil minimum pour pouvoir retirer ses gains (en euros)
export const WITHDRAWAL_MIN_EUR = 10;

// Méthode de paiement active (V1 : PayPal uniquement)
export const PAYMENT_METHOD = 'paypal';

// Pas d'expiration sur les gains (on suit les règles CJ uniquement)
export const GAINS_EXPIRATION_DAYS = null;

/**
 * Retourne le taux de cashback pour un tier donné.
 * @param {string} tier - 'free' | 'basic' | 'premium' | 'gold'
 * @returns {number} taux en décimal (ex: 0.15 pour 15%)
 */
export function getCashbackRate(tier) {
  return CASHBACK_RATES[tier] || CASHBACK_RATES.free;
}

/**
 * Calcule le cashback d'un user basé sur la commission CJ.
 * @param {number} commissionEur - commission nette reçue de CJ (en €)
 * @param {string} tier - tier de l'utilisateur
 * @returns {number} montant du cashback en €, arrondi à 2 décimales
 */
export function calculateCashback(commissionEur, tier) {
  if (!commissionEur || commissionEur <= 0) return 0;
  const rate = getCashbackRate(tier);
  return Math.round(commissionEur * rate * 100) / 100;
}

/**
 * Format d'affichage du taux (pour UI).
 */
export function formatRate(tier) {
  const rate = getCashbackRate(tier);
  return `${Math.round(rate * 100)}%`;
}
